<script lang="ts" setup>
/**
 * This is a pure UI component.
 * The component provides no own click-handler or tab-index.
 * Use it within the aria-list-box component.
 */
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';

defineProps<{
  label: string;
  isSelected?: boolean;
  isActive?: boolean;
}>();

</script>

<template>
  <div
    v-ripple.center
    class="answer-option"
    :class="{
      'answer-option--selected': isSelected,
      'answer-option--active': isActive,
    }"
  >
    <span>{{ label }}</span>
    <svg-illustration v-if="isSelected" name="check.svg" class="answer-option__check"/>
  </div>
</template>

<style lang="scss" scoped>

.answer-option {
  @include font-body-bold;
  width: 100%;
  background-color: var(--btn-background-on-card);
  border-radius: var(--Border-Radius-3);
  padding: var(--Spacing-spacing-3);
  position: relative;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__check {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }

  &--selected {
    color: var(--Neutral-UI-neutral-ui-100);
    background-color: var(--Secondary-secondary-color-1);
  }

  @media (hover: hover) {
    &:not(#{&}--selected):hover {
      background-color: var(--Neutral-UI-neutral-ui-20);
    }
  }

  &:not(#{&}--selected):active {
    background-color: var(--Neutral-UI-neutral-ui-20);
  }
}

// keyboard control only
:focus-visible .answer-option--active {
  @include focus-visible-default-styling;

  &:not(.answer-option--selected) {
    background-color: var(--Neutral-UI-neutral-ui-20);
  }
}

</style>